<template>
    <div id="app">
        <div class="uq" v-if="$route.meta.layout">
            <left-menu />
            <div class="main">
                <top />
                <transition name="fade">
                    <router-view class="router-view" />
                </transition>
            </div>
        </div>
        <div v-else>
            <router-view />
        </div>
    </div>
</template>
<script>
import leftMenu from './components/common/leftMenu.vue'
import top from './components/common/top.vue'

export default {
    components: {
        leftMenu,
        top
    }
}
</script>
<style lang="scss">
body {
    margin: 0;
    background: $color-background;
}
#app {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 16px;
    color: $color-black-1;
    width: 100%;
}
input {
    border-radius: 4px;
    border: 1px #eee solid;
    height: 40px;
    line-height: 40px;
    padding: 0 40px;
    width: calc(100% - 82px);
    font-size: 16px;
    outline: none;
}
.input_place {
    width: 100%;
}
::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: $color-black-4;
}
::-moz-placeholder {
    /* Firefox 19+ */
    color: $color-black-4;
}
:-ms-input-placeholder {
    /* IE 10+ */
    color: $color-black-4;
}
:-moz-placeholder {
    /* Firefox 18- */
    color: $color-black-4;
}
h3 {
    margin: 40px 0 0;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
.uq {
    width: 100%;
    display: flex;
    align-items: stretch;
}
.main {
    width: 100%;
    position: relative;
}
.popup {
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    z-index: 100;
}
.popup_main {
    width: 1000px;
    height: 600px;
    z-index: 100;
    background: #fff;
    border-radius: 4px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    padding: 20px;
    overflow-y: scroll;
}
.popup_title {
    font-size: 24px;
    color: $color-black-2;
    font-family: $font-1;
    font-weight: bold;
    letter-spacing: 2px;
    margin-bottom: 20px;
}
.uq .router-view {
    position: absolute;
    width: calc(100% - 40px);
    margin: 20px;
}
.uq {
    width: 100%;
}
</style>
